import React from 'react'
import styles from './school-cover.styles'
import injectSheet from 'react-jss'
import Section from '../../../../shared/section/section'

import Button from 'pobble-components/dist/button'
import Description from '../../../../shared/description/description'
import FormFile from 'pobble-components/dist/form-elements/form-file'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const SchoolCover = ({
  classes,
  pending,
  title,
  id,
  onRemove,
  onChange,
  url
}) => (
  <Section pending={pending}>
    <div className={classes.container}>
      <div
        className={classes.cover}
        style={{ backgroundImage: 'url(' + url + ')' }}
      />
      <div>
        <div className={classes.actions}>
          <FormFile accept=".jpg,.png" onChange={onChange}>
            <Button span tall wide secondary className={classes.button}>
              Upload image
            </Button>
          </FormFile>
          {url && (
            <Button
              simple
              tall
              action={() =>
                openConfirmationDialog({
                  bodyText: `Are you sure you want to remove the current school cover?`,
                  confirmText: 'Yes',
                  action: () => onRemove(id)
                })
              }>
              Remove
            </Button>
          )}
        </div>
        <Description>
          <p>
            Set a background image for your school profile page. This image will
            appear faded behind your school information as displayed above.{' '}
            <br />
            <br />
            You can upload images of up to 10 MB in size. For optimal result
            please use a landscape sized image.
          </p>
        </Description>
      </div>
    </div>
  </Section>
)

export default injectSheet(styles)(SchoolCover)
